import ymWrapper from '@/lib/ym';
import { useEffect } from 'react';

export function useTrackButtons() {
  useEffect(() => {
    function globalClickHandler(e) {
      console.log('globalClickHandler', e);
      console.log('target', e.target);
      // Find the closest element with data-event-id (in case click is on an inner child)
      const button = e.target.closest('[data-goal-id]');
      if (button) {
        const eventId = button.getAttribute('data-goal-id');
        ymWrapper('reachGoal', eventId);
      }
    }

    document.body.addEventListener('click', globalClickHandler);

    return () => {
      document.body.removeEventListener('click', globalClickHandler);
    };
  }, []);
}
